export const refurbishedProducts = [
  {
    id: 1,
    name: "Steris Amsco QDJ04 Blanket Warmer Refurbished",
    model: "MDYX-AMSCO-QDJ04",
    price: "1830",
    by: "Amsco",
    moq: 3,
    condition: "Certified Refurbished",
    shipping: "Freight Shipping",
    images: ["/Equipments/one/SternisAmsco.webp"],
    feature:
      "The Steris Amsco QDJ04 Blanket Warmer is a cutting-edge solution for maintaining patient comfort in medical facilities worldwide. Its spacious interior accommodates ample blankets, ensuring easy access to warm linens in operating rooms, emergency departments, and patient recovery areas. With adjustable temperature controls and an intuitive interface, healthcare professionals can personalize patient care effortlessly. Safety features like temperature monitoring and secure locking mechanisms provide peace of mind in critical care situations. Reduce linen changes and minimize hypothermia risks with this durable, easy-to-maintain device. When you buy a refurbished item from Us, you can buy it with confidence, knowing the components have been disassembled, inspected, tested, and cleaned during each stage of the process.",
    specifications: [
      {
        title: "Inner Dimensions of the Upper Compartment",
        measurements: ["width: 23.5 in.", "depth: 22 in.", "height: 13 in."],
      },
      {
        title: "Inner Dimensions of the Bottom Compartment",
        measurements: ["width: 23.5 in.", "depth: 22 in.", "height: 38 in."],
      },
      {
        title: "Overall Dimensions of the Unit",
        measurements: [
          "width: 30 in.",
          "depth: 28 in.",
          "height: 75.5 in.",
          "Shipping weight is about 300 pounds",
        ],
      },
    ],
    keyFeatures: [
      "Spacious interior capacity for ample blanket storage",
      "Adjustable temperature controls for personalized patient care",
      "Intuitive interface for effortless operation",
      "Safety features including temperature monitoring and secure locking mechanisms",
      "Durable construction for long-term reliability in medical settings",
    ],
    includedAccessories: [
      "Steris Amsco QDJ04 Warmer",
      "2 Shelves",
      "Power Cord",
      "User Manual",
    ],
    policies: {
      returnPolicy: {
        damagedFreight:
          "Damaged freight must be reported within 24 hours to file a claim.",
        authorizationRequired:
          "No merchandise may be returned without prior written authorization by Medichy.",
        newMerchandise:
          "No new merchandise may be returned without manufacturer authorization, which may result in a restocking fee or denial of return. Customer is responsible for shipping expenses.",
        returnPeriod:
          "Products may be returned within thirty (30) days from delivery unless otherwise agreed upon.",
        inspection:
          "Medichy reserves the right to test returned products and may impose a fee if the condition of the product was misrepresented by the customer.",
      },

      creditAndReturnShippingGuidelines: {
        restockingFee:
          "Order cancellations after 24 hours and returns are subject to a 25% restocking fee.",
        medichyMedicalError:
          "If the return is due to Medichy's error, 100% credit including shipping expenses will be issued.",
        unusedGoods:
          "Unused goods in original packaging may receive a 75% credit. Customer is responsible for shipping expenses both ways unless otherwise agreed.",
        damagedGoods:
          "Credit for damaged goods depends on the condition of the product. Customer is responsible for shipping expenses.",
        nonReturnableItems:
          "No credit will be issued for non-returnable items such as new products, custom orders, special orders, or items damaged due to improper handling or packaging by the customer.",
      },

      shippingCharges: {
        deliveryResponsibility:
          "Customers are responsible for ensuring delivery access for large trucks and equipment.",
        dockToDock:
          "Basic shipping includes dock-to-dock and/or liftgate service for palletized items only and does not include inside delivery.",
        residentialShipping:
          "Residential shipping charges apply for deliveries to residential areas.",
        insideDelivery:
          "Inside delivery includes delivery to the building lobby only and excludes rooms, suites, elevators, and stairs.",
        packingDisposal:
          "Customers are responsible for disposing of packing materials.",
      },

      warranty: {
        refurbishedWarranty:
          "Refurbished products are tested to Medichy quality standards and covered against defects in material or workmanship.",

        coverage: {
          partsAndLabor:
            "90 days parts and labor from the documented date of receipt.",
          extendedWarranty:
            "Extended warranties up to 1 year from purchase date are available.",
        },

        replacementPolicy:
          "Medichy may replace defective products, repair them, or refund the purchase price if replacement or repair is not practical.",

        nonCoveredIssues: [
          "Normal wear and tear",
          "Improper installation",
          "Improper maintenance",
          "Misuse",
          "Abuse",
          "Negligence",
          "Accidents",
          "Alterations",
        ],

        voidConditions:
          "Warranty is void if labels are removed, damaged, tampered with, or if unauthorized alterations are made.",

        warrantyClaimRequirements: [
          "Invoice or proof of purchase",
          "Description of the problem",
          "Return Authorization Number (RMA#)",
        ],

        returnShipping:
          "Repaired or replacement products will be returned postage prepaid.",

        liabilityLimitation:
          "Medichy is not liable for incidental, special, or consequential damages arising from warranty breaches.",

        governingLaw:
          "The laws of the State of Delaware, USA govern these warranties.",
      },
    },
  },
  {
    id: 2,
    name: "Midmark Ritter M11 UltraClave Automatic Sterilizer Refurbished",
    model: "MDYX-MIDMARK-M11",
    price: "3150",
    by: "Midmark Ritter",
    moq: 3,
    condition: "Certified Refurbished",
    shipping: "Freight Shipping",
    images: ["/Equipments/two/MidmarkRitterM11.webp"],
    feature:
      "The Midmark M11 is the largest of the Midmark family of autoclaves. With its 11' x 18' chamber, the M11 has the largest sterilizing capacity of any standard countertop sterilizer on the market. This steam pressure sterilizer features an LCD display with simple prompts that help you easily select the cycle that you need. Once sterilization is complete, the door automatically opens to release excess steam and ensure fast, efficient drying of all products. This product is primarily used in dental offices. When you buy a refurbished item from Medichy, you can buy it with confidence, knowing the components have been disassembled, inspected, tested, and cleaned during each stage of the process.",
    specifications: [
      {
        title: "Overall Dimensions",
        measurements: [
          "Overall length w/plug: 23.8 in (60.5 cm)",
          "Overall width: 17.8 in (45.2 cm)",
          "Overall height: 17.8 in (45.2 cm)",
          "Minimum countertop area: 21 in (53.3 cm) D x 17.8 in (45.2 cm) W",
        ],
      },
      {
        title: "Chamber",
        measurements: [
          "11 in diameter (28 cm)",
          "18 in depth (45.7 cm)",
          "6.5 gal usable volume (24.6 liters)",
        ],
      },
      {
        title: "Trays",
        measurements: [
          "One large – 9 in W x 15 in L x 1.1 in D (22.9 cm x 38 cm x 2.9 cm)",
          "One small – 6.6 in W x 15 in L x 1.1 in D (16.8 cm x 38 cm x 2.9 cm)",
          "Unit weight: 99 lb (44.9 kg)",
          "Shipping weight: 131 lb (59.4 kg)",
          "Water reservoir capacity: 1.4 gal (5.3 liters)",
        ],
      },
      {
        title: "Electrical Requirements",
        measurements: [
          "115 VAC, 50/60 Hz, 15 Amps Single Phase",
          "Meets the requirements of ASME Boiler and Pressure Vessel Code",
          "UL Listed to US & Canadian Standards",
        ],
      },
    ],
    keyFeatures: [
      "Reliable and effective infection control assurance",
      "Patented automatic-opening door for efficient, safe instrument drying",
      "Largest capacity of any standard tabletop autoclave",
      "Self-program controls",
      "Pre-programmed controls for convenience",
    ],
    includedAccessories: ["1 Small tray", "1 Large tray", "Power cord"],
    policies: {
      returnPolicy: {
        damagedFreight:
          "Damaged freight must be reported within 24 hours to file a claim.",
        authorizationRequired:
          "No merchandise may be returned without prior written authorization by Medichy.",
        newMerchandise:
          "No new merchandise may be returned without manufacturer authorization, which may result in a restocking fee or denial of return. Customer is responsible for shipping expenses.",
        returnPeriod:
          "Products may be returned within thirty (30) days from delivery unless otherwise agreed upon.",
        inspection:
          "Medichy reserves the right to test returned products and may impose a fee if the condition of the product was misrepresented by the customer.",
      },

      creditAndReturnShippingGuidelines: {
        restockingFee:
          "Order cancellations after 24 hours and returns are subject to a 25% restocking fee.",
        medichyMedicalError:
          "If the return is due to Medichy's error, 100% credit including shipping expenses will be issued.",
        unusedGoods:
          "Unused goods in original packaging may receive a 75% credit. Customer is responsible for shipping expenses both ways unless otherwise agreed.",
        damagedGoods:
          "Credit for damaged goods depends on the condition of the product. Customer is responsible for shipping expenses.",
        nonReturnableItems:
          "No credit will be issued for non-returnable items such as new products, custom orders, special orders, or items damaged due to improper handling or packaging by the customer.",
      },

      shippingCharges: {
        deliveryResponsibility:
          "Customers are responsible for ensuring delivery access for large trucks and equipment.",
        dockToDock:
          "Basic shipping includes dock-to-dock and/or liftgate service for palletized items only and does not include inside delivery.",
        residentialShipping:
          "Residential shipping charges apply for deliveries to residential areas.",
        insideDelivery:
          "Inside delivery includes delivery to the building lobby only and excludes rooms, suites, elevators, and stairs.",
        packingDisposal:
          "Customers are responsible for disposing of packing materials.",
      },

      warranty: {
        refurbishedWarranty:
          "Refurbished products are tested to Medichy quality standards and covered against defects in material or workmanship.",

        coverage: {
          partsAndLabor:
            "90 days parts and labor from the documented date of receipt.",
          extendedWarranty:
            "Extended warranties up to 1 year from purchase date are available.",
        },

        replacementPolicy:
          "Medichy may replace defective products, repair them, or refund the purchase price if replacement or repair is not practical.",

        nonCoveredIssues: [
          "Normal wear and tear",
          "Improper installation",
          "Improper maintenance",
          "Misuse",
          "Abuse",
          "Negligence",
          "Accidents",
          "Alterations",
        ],

        voidConditions:
          "Warranty is void if labels are removed, damaged, tampered with, or if unauthorized alterations are made.",

        warrantyClaimRequirements: [
          "Invoice or proof of purchase",
          "Description of the problem",
          "Return Authorization Number (RMA#)",
        ],

        returnShipping:
          "Repaired or replacement products will be returned postage prepaid.",

        liabilityLimitation:
          "Medichy is not liable for incidental, special, or consequential damages arising from warranty breaches.",

        governingLaw:
          "The laws of the State of Delaware, USA govern these warranties.",
      },
    },
  },
  {
    id: 3,
    name: "Steris Amsco 3080 Surgical Table Refurbished",
    model: "MDYX-STERIS-3080",
    price: "6430",
    by: "Steris Amsco",
    moq: 5,
    condition: "Certified Refurbished",
    shipping: "Freight Shipping",
    images: ["/Equipments/three/Amsco-3080-Surgical.jpg"],
    feature:
      "The Amsco 3080 is favored because of the image capabilities and the easy patient positioning. The product has efficient C-arm accessibility and is very user-friendly. Its versatility ensures exceptional imaging quality, even during complex procedures. The Amsco is heavily equipped with override protection. The configuration of the product offers the Rc option which can hold up to 400 lbs or the RL/SP which can hold more than 400 lbs. The product is also sold with or without an arm board. When you buy a refurbished Surgical Table from Medichy, you can buy it with confidence, knowing the components have been disassembled, inspected, tested, and cleaned during each stage of the process.",
    keyFeatures: [
      "Radiolucent tabletop",
      "Simple operation",
      "Self leveling brakes",
      "X-Ray cassette deck",
      "Pressure reduction mattress",
      "Manual override foot pump",
      "Built-in backup system",
      "Floor locks",
      "One handed control operation",
      "C-arm access",
      "Weight capacity 500 lbs",
      "Optional foot control",
      "Comes with hand control and new 2 pad set",
    ],
    specifications: [
      {
        title: "Dimensions & Movements",
        measurements: [
          "Max height: 44 in",
          "Min height: 27 in",
          "Lateral tilt: +/- 18°",
          "Trendelenberg: 25°",
          "Reverse trendelenberg: 25°",
          "Reflex: 20°",
          "Flex: 30°",
          "Length: 75.9 in",
          "Width: 20 in",
        ],
      },
    ],
    includedAccessories: ["New 2 Surgical Pad", "Surgical Table", "Power Cord"],
    policies: {
      returnPolicy: {
        damagedFreight:
          "Damaged freight must be reported within 24 hours to file a claim.",
        authorizationRequired:
          "No merchandise may be returned without prior written authorization by Medichy.",
        newMerchandise:
          "No new merchandise may be returned without manufacturer authorization, which may result in a restocking fee or denial of return. Customer is responsible for shipping expenses.",
        returnPeriod:
          "Products may be returned within thirty (30) days from delivery unless otherwise agreed upon.",
        inspection:
          "Medichy reserves the right to test returned products and may impose a fee if the condition of the product was misrepresented by the customer.",
      },

      creditAndReturnShippingGuidelines: {
        restockingFee:
          "Order cancellations after 24 hours and returns are subject to a 25% restocking fee.",
        medichyMedicalError:
          "If the return is due to Medichy's error, 100% credit including shipping expenses will be issued.",
        unusedGoods:
          "Unused goods in original packaging may receive a 75% credit. Customer is responsible for shipping expenses both ways unless otherwise agreed.",
        damagedGoods:
          "Credit for damaged goods depends on the condition of the product. Customer is responsible for shipping expenses.",
        nonReturnableItems:
          "No credit will be issued for non-returnable items such as new products, custom orders, special orders, or items damaged due to improper handling or packaging by the customer.",
      },

      shippingCharges: {
        deliveryResponsibility:
          "Customers are responsible for ensuring delivery access for large trucks and equipment.",
        dockToDock:
          "Basic shipping includes dock-to-dock and/or liftgate service for palletized items only and does not include inside delivery.",
        residentialShipping:
          "Residential shipping charges apply for deliveries to residential areas.",
        insideDelivery:
          "Inside delivery includes delivery to the building lobby only and excludes rooms, suites, elevators, and stairs.",
        packingDisposal:
          "Customers are responsible for disposing of packing materials.",
      },

      warranty: {
        refurbishedWarranty:
          "Refurbished products are tested to Medichy quality standards and covered against defects in material or workmanship.",

        coverage: {
          partsAndLabor:
            "90 days parts and labor from the documented date of receipt.",
          extendedWarranty:
            "Extended warranties up to 1 year from purchase date are available.",
        },

        replacementPolicy:
          "Medichy may replace defective products, repair them, or refund the purchase price if replacement or repair is not practical.",

        nonCoveredIssues: [
          "Normal wear and tear",
          "Improper installation",
          "Improper maintenance",
          "Misuse",
          "Abuse",
          "Negligence",
          "Accidents",
          "Alterations",
        ],

        voidConditions:
          "Warranty is void if labels are removed, damaged, tampered with, or if unauthorized alterations are made.",

        warrantyClaimRequirements: [
          "Invoice or proof of purchase",
          "Description of the problem",
          "Return Authorization Number (RMA#)",
        ],

        returnShipping:
          "Repaired or replacement products will be returned postage prepaid.",

        liabilityLimitation:
          "Medichy is not liable for incidental, special, or consequential damages arising from warranty breaches.",

        governingLaw:
          "The laws of the State of Delaware, USA govern these warranties.",
      },
    },
  },
  {
    id: 4,
    name: "Stryker Smart Tourniquet Pump Dual Channel - Refurbished",
    model: "MDYX-STRYKER-5920",
    price: "2295",
    by: "Stryker",
    moq: 5,
    condition: "Certified Refurbished",
    shipping: "Freight Shipping",
    images: ["/Equipments/four/stryker.webp"],
    feature:
      "The Stryker SmartPump is a dual channel tourniquet pump. It is designed for use by qualified medical personnel to temporarily impede blood flow in a patient's extremity in order to create a blood-free surgical zone. Its dual channel design supports single cuff, bilateral and Bier Block procedures, and allows for simultaneous surgery of both an upper and lower limb. Each cuff's unique pressure and time settings are displayed, controlled, and monitored independently. The SmartPump uses single port cuffs.",
    keyFeatures: [
      "The procedure timer and cuff target pressure may be set using simple, intuitive steps. Control buttons are clearly identified.",
      "Inflation is initiated by pressing the Inflate button.",
      "Deflation is initiated by pressing and holding the Deflate button for 1.5 seconds.",
      "The large, bright, backlit LCD display shows total elapsed cuff inflation time and cuff pressure (mmHg). The displayed time format is user selectable: minutes or hours and minutes.",
    ],
    specifications: [
      {
        title: "Dimensions",
        measurements: [
          "Height: 15.5 in (39.4 cm)",
          "Width: 10 in (25.4 cm)",
          "Depth: 9 in (22.9 cm)",
          "Weight: 12 lbs (5.45 kg)",
        ],
      },
      {
        title: "Power Source",
        measurements: [
          "AC Input: 100 - 240 VAC 50/60 Hz universal switching power supply",
          "Automatic internal battery switchover for AC-free use or AC loss protection",
          "Facility power: 120 VAC, 10A, hospital grade receptacle",
        ],
      },
    ],
    includedAccessories: [],
    policies: {
      returnPolicy: {
        damagedFreight:
          "Damaged freight must be reported within 24 hours to file a claim.",
        authorizationRequired:
          "No merchandise may be returned without prior written authorization by Medichy.",
        newMerchandise:
          "No new merchandise may be returned without manufacturer authorization, which may result in a restocking fee or denial of return. Customer is responsible for shipping expenses.",
        returnPeriod:
          "Products may be returned within thirty (30) days from delivery unless otherwise agreed upon.",
        inspection:
          "Medichy reserves the right to test returned products and may impose a fee if the condition of the product was misrepresented by the customer.",
      },

      creditAndReturnShippingGuidelines: {
        restockingFee:
          "Order cancellations after 24 hours and returns are subject to a 25% restocking fee.",
        medichyMedicalError:
          "If the return is due to Medichy's error, 100% credit including shipping expenses will be issued.",
        unusedGoods:
          "Unused goods in original packaging may receive a 75% credit. Customer is responsible for shipping expenses both ways unless otherwise agreed.",
        damagedGoods:
          "Credit for damaged goods depends on the condition of the product. Customer is responsible for shipping expenses.",
        nonReturnableItems:
          "No credit will be issued for non-returnable items such as new products, custom orders, special orders, or items damaged due to improper handling or packaging by the customer.",
      },

      shippingCharges: {
        deliveryResponsibility:
          "Customers are responsible for ensuring delivery access for large trucks and equipment.",
        dockToDock:
          "Basic shipping includes dock-to-dock and/or liftgate service for palletized items only and does not include inside delivery.",
        residentialShipping:
          "Residential shipping charges apply for deliveries to residential areas.",
        insideDelivery:
          "Inside delivery includes delivery to the building lobby only and excludes rooms, suites, elevators, and stairs.",
        packingDisposal:
          "Customers are responsible for disposing of packing materials.",
      },

      warranty: {
        refurbishedWarranty:
          "Refurbished products are tested to Medichy quality standards and covered against defects in material or workmanship.",

        coverage: {
          partsAndLabor:
            "90 days parts and labor from the documented date of receipt.",
          extendedWarranty:
            "Extended warranties up to 1 year from purchase date are available.",
        },

        replacementPolicy:
          "Medichy may replace defective products, repair them, or refund the purchase price if replacement or repair is not practical.",

        nonCoveredIssues: [
          "Normal wear and tear",
          "Improper installation",
          "Improper maintenance",
          "Misuse",
          "Abuse",
          "Negligence",
          "Accidents",
          "Alterations",
        ],

        voidConditions:
          "Warranty is void if labels are removed, damaged, tampered with, or if unauthorized alterations are made.",

        warrantyClaimRequirements: [
          "Invoice or proof of purchase",
          "Description of the problem",
          "Return Authorization Number (RMA#)",
        ],

        returnShipping:
          "Repaired or replacement products will be returned postage prepaid.",

        liabilityLimitation:
          "Medichy is not liable for incidental, special, or consequential damages arising from warranty breaches.",

        governingLaw:
          "The laws of the State of Delaware, USA govern these warranties.",
      },
    },
  },
  {
    id: 5,
    name: "GE Datex-Ohmeda Aestiva 5 Anesthesia Machine - Refurbished",
    model: "MDYX-GE-AESTIVA5",
    price: "7995",
    by: "GE Datex Ohmeda",
    moq: 3,
    condition: "Certified Refurbished",
    shipping: "Freight Shipping",
    images: [
      "/Equipments/five/one.webp",
      "/Equipments/five/two.webp",
      "/Equipments/five/three.jpg",
      "/Equipments/five/four.webp",
    ],
    feature:
      "The Datex-Ohmeda Aestiva/5 Anesthesia Machine is wanted because of the unique features that integrate a breathing circuit, which enhances cable management and patient safety. These features are used to safeguard components from damage and disconnection. Smart sensors and switches ensure continuous communication between the breathing circuit and the Smart Vent ventilator. The Aestiva 5 includes the 7100 ventilators, which offers a diverse set of capabilities such as optimal tidal volume compensation and integrated volume and oxygen monitoring. Praised for its patient-centered engineering and clinician-oriented efficiency, it's recognized as a standout anesthesia system. When you buy a refurbished Anesthesia Machine from Medichy, you can buy it with confidence, knowing the components have been disassembled, inspected, tested, and cleaned during each stage of the process.",
    keyFeatures: [
      "Advanced Breathing System (ABS)",
      "Easy to clean, autoclavable, latex-free",
      "Fast response - exceptional for low flow anesthesia",
      "Easy removal - no tools required",
      "Integrated design - less parts and connections helps reduce potential for leaks and misconnects",
      "One step bag/vent switch turns ventilator on/off",
    ],
    specifications: [
      {
        title: "Dimensions (2 Vap)",
        measurements: [
          "Height: 53.4 in (135.8 cm)",
          "Width: 29.5 in (75 cm)",
          "Depth: 32.7 in (83 cm)",
          "Weight: 300 lb (136 kg)",
        ],
      },
      {
        title: "Dimensions (3 Vap)",
        measurements: [
          "Height: 53.4 in (135.8 cm)",
          "Width: 36.6 in (93 cm)",
          "Depth: 32.7 in (83 cm)",
          "Weight: 340 lb (154 kg)",
        ],
      },
    ],
    includedAccessories: ["Power Cord", "User Manual"],
    policies: {
      returnPolicy: {
        damagedFreight:
          "Damaged freight must be reported within 24 hours to file a claim.",
        authorizationRequired:
          "No merchandise may be returned without prior written authorization by Medichy.",
        newMerchandise:
          "No new merchandise may be returned without manufacturer authorization, which may result in a restocking fee or denial of return. Customer is responsible for shipping expenses.",
        returnPeriod:
          "Products may be returned within thirty (30) days from delivery unless otherwise agreed upon.",
        inspection:
          "Medichy reserves the right to test returned products and may impose a fee if the condition of the product was misrepresented by the customer.",
      },

      creditAndReturnShippingGuidelines: {
        restockingFee:
          "Order cancellations after 24 hours and returns are subject to a 25% restocking fee.",
        medichyMedicalError:
          "If the return is due to Medichy's error, 100% credit including shipping expenses will be issued.",
        unusedGoods:
          "Unused goods in original packaging may receive a 75% credit. Customer is responsible for shipping expenses both ways unless otherwise agreed.",
        damagedGoods:
          "Credit for damaged goods depends on the condition of the product. Customer is responsible for shipping expenses.",
        nonReturnableItems:
          "No credit will be issued for non-returnable items such as new products, custom orders, special orders, or items damaged due to improper handling or packaging by the customer.",
      },

      shippingCharges: {
        deliveryResponsibility:
          "Customers are responsible for ensuring delivery access for large trucks and equipment.",
        dockToDock:
          "Basic shipping includes dock-to-dock and/or liftgate service for palletized items only and does not include inside delivery.",
        residentialShipping:
          "Residential shipping charges apply for deliveries to residential areas.",
        insideDelivery:
          "Inside delivery includes delivery to the building lobby only and excludes rooms, suites, elevators, and stairs.",
        packingDisposal:
          "Customers are responsible for disposing of packing materials.",
      },

      warranty: {
        refurbishedWarranty:
          "Refurbished products are tested to Medichy quality standards and covered against defects in material or workmanship.",

        coverage: {
          partsAndLabor:
            "90 days parts and labor from the documented date of receipt.",
          extendedWarranty:
            "Extended warranties up to 1 year from purchase date are available.",
        },

        replacementPolicy:
          "Medichy may replace defective products, repair them, or refund the purchase price if replacement or repair is not practical.",

        nonCoveredIssues: [
          "Normal wear and tear",
          "Improper installation",
          "Improper maintenance",
          "Misuse",
          "Abuse",
          "Negligence",
          "Accidents",
          "Alterations",
        ],

        voidConditions:
          "Warranty is void if labels are removed, damaged, tampered with, or if unauthorized alterations are made.",

        warrantyClaimRequirements: [
          "Invoice or proof of purchase",
          "Description of the problem",
          "Return Authorization Number (RMA#)",
        ],

        returnShipping:
          "Repaired or replacement products will be returned postage prepaid.",

        liabilityLimitation:
          "Medichy is not liable for incidental, special, or consequential damages arising from warranty breaches.",

        governingLaw:
          "The laws of the State of Delaware, USA govern these warranties.",
      },
    },
  },
  {
    id: 6,
    name: "Hill-Rom CareAssist ES Hospital Bed Refurbished",
    model: "MDYX-HILLROM-CARE",
    price: "3190",
    by: "Hill-Rom",
    moq: 6,
    condition: "Certified Refurbished",
    shipping: "Freight Shipping",
    images: ["/Equipments/six/HILL-CARE-ES.webp"],
    feature:
      "The Hill-Rom CareAssist ES is an easy-to-use bed that uses high tech capabilities to help caregivers with providing comfort to patients. Best for use in hospitals and home care, the bed has many features that give healthcare providers efficiency when caring for patients. The bed's open and flat sleep deck allows you to use a wide range of commercially available mattresses. When you buy a refurbished item from Medichy, you can buy it with confidence, knowing the components have been disassembled, inspected, tested, and cleaned during each stage of the process.",
    specifications: [
      {
        title: "Measurements",
        measurements: [
          "Low position (floor to deck): 15.75 in",
          "High position (floor to deck): 32.5 in",
          "Sleep surface width: 35.25 in",
          "Sleep surface length: 80 in (normal), 84 in (fully extended)",
          "Overall width (side rails up): 40 in",
          "Approximate bed weight: 420 lbs (without surface)",
          "Weight capacity: 500 lbs",
          "Maximum back angle: 65°",
        ],
      },
    ],
    keyFeatures: [
      "Hand control – bed high/low, head/knee up/down, Trendelenburg/Reverse Trendelenburg",
      "Audible 'brake not set' alarm",
      "SlideGuard bed articulation technology",
      "Electric vascular foot position",
      "Dining Chair One Button Feature",
      "One-hand bed extender",
      "Mattress stops",
      "Battery backup",
      "Lockout controls",
    ],
    includedAccessories: [
      "Hospital grade mattress",
      "Hospital bed",
      "Power Cord",
    ],
    policies: {
      returnPolicy: {
        damagedFreight:
          "Damaged freight must be reported within 24 hours to file a claim.",
        authorizationRequired:
          "No merchandise may be returned without prior written authorization by Medichy.",
        newMerchandise:
          "No new merchandise may be returned without manufacturer authorization, which may result in a restocking fee or denial of return. Customer is responsible for shipping expenses.",
        returnPeriod:
          "Products may be returned within thirty (30) days from delivery unless otherwise agreed upon.",
        inspection:
          "Medichy reserves the right to test returned products and may impose a fee if the condition of the product was misrepresented by the customer.",
      },

      creditAndReturnShippingGuidelines: {
        restockingFee:
          "Order cancellations after 24 hours and returns are subject to a 25% restocking fee.",
        medichyMedicalError:
          "If the return is due to Medichy's error, 100% credit including shipping expenses will be issued.",
        unusedGoods:
          "Unused goods in original packaging may receive a 75% credit. Customer is responsible for shipping expenses both ways unless otherwise agreed.",
        damagedGoods:
          "Credit for damaged goods depends on the condition of the product. Customer is responsible for shipping expenses.",
        nonReturnableItems:
          "No credit will be issued for non-returnable items such as new products, custom orders, special orders, or items damaged due to improper handling or packaging by the customer.",
      },

      shippingCharges: {
        deliveryResponsibility:
          "Customers are responsible for ensuring delivery access for large trucks and equipment.",
        dockToDock:
          "Basic shipping includes dock-to-dock and/or liftgate service for palletized items only and does not include inside delivery.",
        residentialShipping:
          "Residential shipping charges apply for deliveries to residential areas.",
        insideDelivery:
          "Inside delivery includes delivery to the building lobby only and excludes rooms, suites, elevators, and stairs.",
        packingDisposal:
          "Customers are responsible for disposing of packing materials.",
      },

      warranty: {
        refurbishedWarranty:
          "Refurbished products are tested to Medichy quality standards and covered against defects in material or workmanship.",

        coverage: {
          partsAndLabor:
            "90 days parts and labor from the documented date of receipt.",
          extendedWarranty:
            "Extended warranties up to 1 year from purchase date are available.",
        },

        replacementPolicy:
          "Medichy may replace defective products, repair them, or refund the purchase price if replacement or repair is not practical.",

        nonCoveredIssues: [
          "Normal wear and tear",
          "Improper installation",
          "Improper maintenance",
          "Misuse",
          "Abuse",
          "Negligence",
          "Accidents",
          "Alterations",
        ],

        voidConditions:
          "Warranty is void if labels are removed, damaged, tampered with, or if unauthorized alterations are made.",

        warrantyClaimRequirements: [
          "Invoice or proof of purchase",
          "Description of the problem",
          "Return Authorization Number (RMA#)",
        ],

        returnShipping:
          "Repaired or replacement products will be returned postage prepaid.",

        liabilityLimitation:
          "Medichy is not liable for incidental, special, or consequential damages arising from warranty breaches.",

        governingLaw:
          "The laws of the State of Delaware, USA govern these warranties.",
      },
    },
  },
  {
    id: 7,
    name: "Midmark 491 Power Otolaryngology Chair - Refurbished",
    model: "MDYX-MIDMARK-491",
    price: "4390",
    by: "Midmark Ritter",
    moq: 6,
    condition: "Certified Refurbished",
    shipping: "Freight Shipping",
    images: ["/Equipments/seven/MIDRAK-491-0123.webp"],
    feature:
      "The Midmark 491 power table is favored for its precise patient positioning and comfortable features. Its low height of just 22 inches makes it easy for patients to get on and off, as well as to be positioned effectively during procedures. Controls are accessible on both sides of the table, and an optional foot control is available for added convenience. The backrest, height adjustment, and auto return functions are all easily operated with the touch of a button. Additionally, the base rotates 330 degrees, providing exceptional positioning flexibility. The table's stability ensures both the physician and patient feel secure and comfortable. When you buy a refurbished Chair from Medichy, you can buy it with confidence, knowing the components have been disassembled, inspected, tested, and cleaned during each stage of the process.",
    specifications: [
      {
        title: "Weight & Dimensions",
        measurements: [
          "Without Shipping Carton: 350 lb (158.8 kg)",
          "With Shipping Carton: 375 lb (170.0 kg)",
          "Shipping Carton: 32 in L x 29 in W x 46 in H",
        ],
      },
      {
        title: "Table Top",
        measurements: [
          "Length (w/ headrest): 75 in (190.5 cm)",
          "Width (w/o arm rests): 19.5 in (49.5 cm)",
          "Overall Width: 26 in (66.4 cm)",
          "Rotation: 330°",
          "Back Section: 2 to 90°",
          "Height (Adjustable): 22.0 in to 31.0 in (55.9 cm to 78.7 cm)",
          "Weight Capacity: 300 lb (136.0 kg)",
        ],
      },
    ],
    keyFeatures: [
      "Low height capability",
      "Optional foot control available",
      "Back, height adjustment, and auto return operated at the touch of a button",
      "Table up/down, Back up/down, Auto return, Armrests",
    ],
    includedAccessories: [],
    policies: {
      returnPolicy: {
        damagedFreight:
          "Damaged freight must be reported within 24 hours to file a claim.",
        authorizationRequired:
          "No merchandise may be returned without prior written authorization by Medichy.",
        newMerchandise:
          "No new merchandise may be returned without manufacturer authorization, which may result in a restocking fee or denial of return. Customer is responsible for shipping expenses.",
        returnPeriod:
          "Products may be returned within thirty (30) days from delivery unless otherwise agreed upon.",
        inspection:
          "Medichy reserves the right to test returned products and may impose a fee if the condition of the product was misrepresented by the customer.",
      },

      creditAndReturnShippingGuidelines: {
        restockingFee:
          "Order cancellations after 24 hours and returns are subject to a 25% restocking fee.",
        medichyMedicalError:
          "If the return is due to Medichy's error, 100% credit including shipping expenses will be issued.",
        unusedGoods:
          "Unused goods in original packaging may receive a 75% credit. Customer is responsible for shipping expenses both ways unless otherwise agreed.",
        damagedGoods:
          "Credit for damaged goods depends on the condition of the product. Customer is responsible for shipping expenses.",
        nonReturnableItems:
          "No credit will be issued for non-returnable items such as new products, custom orders, special orders, or items damaged due to improper handling or packaging by the customer.",
      },

      shippingCharges: {
        deliveryResponsibility:
          "Customers are responsible for ensuring delivery access for large trucks and equipment.",
        dockToDock:
          "Basic shipping includes dock-to-dock and/or liftgate service for palletized items only and does not include inside delivery.",
        residentialShipping:
          "Residential shipping charges apply for deliveries to residential areas.",
        insideDelivery:
          "Inside delivery includes delivery to the building lobby only and excludes rooms, suites, elevators, and stairs.",
        packingDisposal:
          "Customers are responsible for disposing of packing materials.",
      },

      warranty: {
        refurbishedWarranty:
          "Refurbished products are tested to Medichy quality standards and covered against defects in material or workmanship.",

        coverage: {
          partsAndLabor:
            "90 days parts and labor from the documented date of receipt.",
          extendedWarranty:
            "Extended warranties up to 1 year from purchase date are available.",
        },

        replacementPolicy:
          "Medichy may replace defective products, repair them, or refund the purchase price if replacement or repair is not practical.",

        nonCoveredIssues: [
          "Normal wear and tear",
          "Improper installation",
          "Improper maintenance",
          "Misuse",
          "Abuse",
          "Negligence",
          "Accidents",
          "Alterations",
        ],

        voidConditions:
          "Warranty is void if labels are removed, damaged, tampered with, or if unauthorized alterations are made.",

        warrantyClaimRequirements: [
          "Invoice or proof of purchase",
          "Description of the problem",
          "Return Authorization Number (RMA#)",
        ],

        returnShipping:
          "Repaired or replacement products will be returned postage prepaid.",

        liabilityLimitation:
          "Medichy is not liable for incidental, special, or consequential damages arising from warranty breaches.",

        governingLaw:
          "The laws of the State of Delaware, USA govern these warranties.",
      },
    },
  },
  {
    id: 8,
    name: "Tuttnauer EZ10 Autoclave Refurbished",
    model: "MDYX-TUTTNAUER-EZ10",
    price: "4295",
    by: "Tuttnauer",
    moq: 6,
    condition: "Certified Refurbished",
    shipping: "Freight Shipping",
    images: ["/Equipments/eight/TUTTNAUER-EZ10.webp"],
    feature:
      "The Tuttnauer EZ10 is a fully automatic autoclave that features a one touch design to fulfill all your sterilization and drying needs. This steam pressure autoclave is used in a range of settings, including active surgery centers, medical practice, dental offices, schools, veterinary facilities, doctor's clinics, or tattoo establishments. The EZ10 utilizes a brighter and easier to read panel that helps it deliver full penetration of steam and post-vacuum drying. The panel includes program selection, a detailed digital display, programmable keys, and system indicators. When you buy a refurbished item from Medichy, you can buy it with confidence, knowing the components have been disassembled, inspected, tested, and cleaned during each stage of the process.",
    keyFeatures: [
      "High efficiency air pump circulates hot air for fast drying after sterilization",
      "Pre-Loaded Cycles",
      "All program parameters can be customized and stored",
      "Automatic shut off at the end of both sterilization and dry cycles",
      "Constant pressure and temperature monitoring",
      "Drain valve located in the front, allowing for quick and easy draining of the water reservoir",
    ],
    specifications: [],
    includedAccessories: [],
    policies: {
      returnPolicy: {
        damagedFreight:
          "Damaged freight must be reported within 24 hours to file a claim.",
        authorizationRequired:
          "No merchandise may be returned without prior written authorization by Medichy.",
        newMerchandise:
          "No new merchandise may be returned without manufacturer authorization, which may result in a restocking fee or denial of return. Customer is responsible for shipping expenses.",
        returnPeriod:
          "Products may be returned within thirty (30) days from delivery unless otherwise agreed upon.",
        inspection:
          "Medichy reserves the right to test returned products and may impose a fee if the condition of the product was misrepresented by the customer.",
      },

      creditAndReturnShippingGuidelines: {
        restockingFee:
          "Order cancellations after 24 hours and returns are subject to a 25% restocking fee.",
        medichyMedicalError:
          "If the return is due to Medichy's error, 100% credit including shipping expenses will be issued.",
        unusedGoods:
          "Unused goods in original packaging may receive a 75% credit. Customer is responsible for shipping expenses both ways unless otherwise agreed.",
        damagedGoods:
          "Credit for damaged goods depends on the condition of the product. Customer is responsible for shipping expenses.",
        nonReturnableItems:
          "No credit will be issued for non-returnable items such as new products, custom orders, special orders, or items damaged due to improper handling or packaging by the customer.",
      },

      shippingCharges: {
        deliveryResponsibility:
          "Customers are responsible for ensuring delivery access for large trucks and equipment.",
        dockToDock:
          "Basic shipping includes dock-to-dock and/or liftgate service for palletized items only and does not include inside delivery.",
        residentialShipping:
          "Residential shipping charges apply for deliveries to residential areas.",
        insideDelivery:
          "Inside delivery includes delivery to the building lobby only and excludes rooms, suites, elevators, and stairs.",
        packingDisposal:
          "Customers are responsible for disposing of packing materials.",
      },

      warranty: {
        refurbishedWarranty:
          "Refurbished products are tested to Medichy quality standards and covered against defects in material or workmanship.",

        coverage: {
          partsAndLabor:
            "90 days parts and labor from the documented date of receipt.",
          extendedWarranty:
            "Extended warranties up to 1 year from purchase date are available.",
        },

        replacementPolicy:
          "Medichy may replace defective products, repair them, or refund the purchase price if replacement or repair is not practical.",

        nonCoveredIssues: [
          "Normal wear and tear",
          "Improper installation",
          "Improper maintenance",
          "Misuse",
          "Abuse",
          "Negligence",
          "Accidents",
          "Alterations",
        ],

        voidConditions:
          "Warranty is void if labels are removed, damaged, tampered with, or if unauthorized alterations are made.",

        warrantyClaimRequirements: [
          "Invoice or proof of purchase",
          "Description of the problem",
          "Return Authorization Number (RMA#)",
        ],

        returnShipping:
          "Repaired or replacement products will be returned postage prepaid.",

        liabilityLimitation:
          "Medichy is not liable for incidental, special, or consequential damages arising from warranty breaches.",

        governingLaw:
          "The laws of the State of Delaware, USA govern these warranties.",
      },
    },
  },
  {
    id: 9,
    name: "Covidien Valleylab Force Triad - Refurbished",
    model: "MDYX-VALLEYLAB-FORCE",
    price: "6790",
    by: "Covidien",
    moq: 5,
    condition: "Certified Refurbished",
    shipping: "Freight Shipping",
    images: ["/Equipments/nine/one.jpg", "/Equipments/nine/two.jpg"],
    feature:
      "The Covidien Valleylab Force Triad is an all-in-one unit compatible with common electrosurgical instruments and all current and new LigaSure instruments. The FX unifies monopolar, bipolar, and vessel sealing, making it an efficient and powerful tool in the operating room. It offers the surgeon everything they need, including electrosurgical cutting and coagulation, bipolar function and LigaSure tissue fusion. When you buy a refurbished item from Medichy, you can buy it with confidence, knowing the components have been disassembled, inspected, tested, and cleaned during each stage of the process.",
    keyFeatures: [
      "Faster fusion cycles than the original LigaSure vessel sealing generator",
      "Easy-to-use touchscreen setup",
      "Reduces demands on staff during procedures",
      "Automatic instrument recognition",
      "Quick and efficient power and mode adjustments from within the sterile field for shorter procedures",
    ],
    specifications: [
      {
        title: "Dimensions",
        measurements: [
          "Width: 18 in (45.7 cm)",
          "Depth: 20 in (50.8 cm)",
          "Height: 10 in (25.4 cm)",
          "Weight: 30 lb (13.6 kg)",
        ],
      },
    ],
    includedAccessories: ["Valleylab FT6003 Force Triad 3-pedal", "Power cord"],
    policies: {
      returnPolicy: {
        damagedFreight:
          "Damaged freight must be reported within 24 hours to file a claim.",
        authorizationRequired:
          "No merchandise may be returned without prior written authorization by Medichy.",
        newMerchandise:
          "No new merchandise may be returned without manufacturer authorization, which may result in a restocking fee or denial of return. Customer is responsible for shipping expenses.",
        returnPeriod:
          "Products may be returned within thirty (30) days from delivery unless otherwise agreed upon.",
        inspection:
          "Medichy reserves the right to test returned products and may impose a fee if the condition of the product was misrepresented by the customer.",
      },

      creditAndReturnShippingGuidelines: {
        restockingFee:
          "Order cancellations after 24 hours and returns are subject to a 25% restocking fee.",
        medichyMedicalError:
          "If the return is due to Medichy's error, 100% credit including shipping expenses will be issued.",
        unusedGoods:
          "Unused goods in original packaging may receive a 75% credit. Customer is responsible for shipping expenses both ways unless otherwise agreed.",
        damagedGoods:
          "Credit for damaged goods depends on the condition of the product. Customer is responsible for shipping expenses.",
        nonReturnableItems:
          "No credit will be issued for non-returnable items such as new products, custom orders, special orders, or items damaged due to improper handling or packaging by the customer.",
      },

      shippingCharges: {
        deliveryResponsibility:
          "Customers are responsible for ensuring delivery access for large trucks and equipment.",
        dockToDock:
          "Basic shipping includes dock-to-dock and/or liftgate service for palletized items only and does not include inside delivery.",
        residentialShipping:
          "Residential shipping charges apply for deliveries to residential areas.",
        insideDelivery:
          "Inside delivery includes delivery to the building lobby only and excludes rooms, suites, elevators, and stairs.",
        packingDisposal:
          "Customers are responsible for disposing of packing materials.",
      },

      warranty: {
        refurbishedWarranty:
          "Refurbished products are tested to Medichy quality standards and covered against defects in material or workmanship.",

        coverage: {
          partsAndLabor:
            "90 days parts and labor from the documented date of receipt.",
          extendedWarranty:
            "Extended warranties up to 1 year from purchase date are available.",
        },

        replacementPolicy:
          "Medichy may replace defective products, repair them, or refund the purchase price if replacement or repair is not practical.",

        nonCoveredIssues: [
          "Normal wear and tear",
          "Improper installation",
          "Improper maintenance",
          "Misuse",
          "Abuse",
          "Negligence",
          "Accidents",
          "Alterations",
        ],

        voidConditions:
          "Warranty is void if labels are removed, damaged, tampered with, or if unauthorized alterations are made.",

        warrantyClaimRequirements: [
          "Invoice or proof of purchase",
          "Description of the problem",
          "Return Authorization Number (RMA#)",
        ],

        returnShipping:
          "Repaired or replacement products will be returned postage prepaid.",

        liabilityLimitation:
          "Medichy is not liable for incidental, special, or consequential damages arising from warranty breaches.",

        governingLaw:
          "The laws of the State of Delaware, USA govern these warranties.",
      },
    },
  },
  {
    id: 10,
    name: "Steris QDJ06 Dual Compartment Glass Door Blanket Warmer - Refurbished",
    model: "MDYX-STERIS-QDJ06",
    price: "4690",
    by: "Steris",
    moq: 5,
    condition: "Certified Refurbished",
    shipping: "Freight Shipping",
    images: ["/Equipments/ten/Steris-QDJ06-0123.webp"],
    feature:
      "The Steris QDJ06 Dual Compartment Glass Door Blanket Warmer provides efficient warming solutions for medical facilities. Its dual compartment design allows for separate temperature settings, while the glass door provides easy visibility of contents. When you buy a refurbished item from Medichy, you can buy it with confidence, knowing the components have been disassembled, inspected, tested, and cleaned during each stage of the process.",
    keyFeatures: [
      "Dual compartment design for separate temperature control",
      "Glass door for easy visibility",
      "Spacious interior capacity",
      "Adjustable temperature controls",
      "Durable construction for long-term reliability",
    ],
    specifications: [
      {
        title: "Dimensions",
        measurements: [
          "Width: 30 in",
          "Depth: 28 in",
          "Height: 75.5 in",
          "Shipping weight: approximately 300 lbs",
        ],
      },
    ],
    includedAccessories: ["Shelves", "Power Cord", "User Manual"],
    policies: {
      returnPolicy: {
        damagedFreight:
          "Damaged freight must be reported within 24 hours to file a claim.",
        authorizationRequired:
          "No merchandise may be returned without prior written authorization by Medichy.",
        newMerchandise:
          "No new merchandise may be returned without manufacturer authorization, which may result in a restocking fee or denial of return. Customer is responsible for shipping expenses.",
        returnPeriod:
          "Products may be returned within thirty (30) days from delivery unless otherwise agreed upon.",
        inspection:
          "Medichy reserves the right to test returned products and may impose a fee if the condition of the product was misrepresented by the customer.",
      },

      creditAndReturnShippingGuidelines: {
        restockingFee:
          "Order cancellations after 24 hours and returns are subject to a 25% restocking fee.",
        medichyMedicalError:
          "If the return is due to Medichy's error, 100% credit including shipping expenses will be issued.",
        unusedGoods:
          "Unused goods in original packaging may receive a 75% credit. Customer is responsible for shipping expenses both ways unless otherwise agreed.",
        damagedGoods:
          "Credit for damaged goods depends on the condition of the product. Customer is responsible for shipping expenses.",
        nonReturnableItems:
          "No credit will be issued for non-returnable items such as new products, custom orders, special orders, or items damaged due to improper handling or packaging by the customer.",
      },

      shippingCharges: {
        deliveryResponsibility:
          "Customers are responsible for ensuring delivery access for large trucks and equipment.",
        dockToDock:
          "Basic shipping includes dock-to-dock and/or liftgate service for palletized items only and does not include inside delivery.",
        residentialShipping:
          "Residential shipping charges apply for deliveries to residential areas.",
        insideDelivery:
          "Inside delivery includes delivery to the building lobby only and excludes rooms, suites, elevators, and stairs.",
        packingDisposal:
          "Customers are responsible for disposing of packing materials.",
      },

      warranty: {
        refurbishedWarranty:
          "Refurbished products are tested to Medichy quality standards and covered against defects in material or workmanship.",

        coverage: {
          partsAndLabor:
            "90 days parts and labor from the documented date of receipt.",
          extendedWarranty:
            "Extended warranties up to 1 year from purchase date are available.",
        },

        replacementPolicy:
          "Medichy may replace defective products, repair them, or refund the purchase price if replacement or repair is not practical.",

        nonCoveredIssues: [
          "Normal wear and tear",
          "Improper installation",
          "Improper maintenance",
          "Misuse",
          "Abuse",
          "Negligence",
          "Accidents",
          "Alterations",
        ],

        voidConditions:
          "Warranty is void if labels are removed, damaged, tampered with, or if unauthorized alterations are made.",

        warrantyClaimRequirements: [
          "Invoice or proof of purchase",
          "Description of the problem",
          "Return Authorization Number (RMA#)",
        ],

        returnShipping:
          "Repaired or replacement products will be returned postage prepaid.",

        liabilityLimitation:
          "Medichy is not liable for incidental, special, or consequential damages arising from warranty breaches.",

        governingLaw:
          "The laws of the State of Delaware, USA govern these warranties.",
      },
    },
  },
  {
    id: 11,
    name: "Wells Johnson Hercules Aspirator - Refurbished",
    model: "MDYX-WELLS-HERCULES",
    price: "4295",
    by: "Wells Johnson",
    moq: 5,
    condition: "Certified Refurbished",
    shipping: "Freight Shipping",
    images: ["/Equipments/eleven/WELLS-MERC-22536.webp"],
    feature:
      "Wells Johnson Hercules Aspirator is a high-performance medical suction device designed for various clinical applications.",
    keyFeatures: [
      "Weight: 73 lb",
      "Dimensions: 18.5 x 18 x 15 in",
      "Maximum Vacuum: 29+ inches Hg",
      "Maximum Flow Rate: 6.8 cubic feet per minute (approx 192.55 LPM)",
      "Sound Level: 53 ± 3 db @ 6 feet",
      "Pump Type: 2 cylinder piston",
      "Number of Pumps: 3",
      "Horsepower: 1 hp",
    ],
    specifications: [],
    includedAccessories: [],
    policies: {
      returnPolicy: {
        damagedFreight:
          "Damaged freight must be reported within 24 hours to file a claim.",
        authorizationRequired:
          "No merchandise may be returned without prior written authorization by Medichy.",
        newMerchandise:
          "No new merchandise may be returned without manufacturer authorization, which may result in a restocking fee or denial of return. Customer is responsible for shipping expenses.",
        returnPeriod:
          "Products may be returned within thirty (30) days from delivery unless otherwise agreed upon.",
        inspection:
          "Medichy reserves the right to test returned products and may impose a fee if the condition of the product was misrepresented by the customer.",
      },

      creditAndReturnShippingGuidelines: {
        restockingFee:
          "Order cancellations after 24 hours and returns are subject to a 25% restocking fee.",
        medichyMedicalError:
          "If the return is due to Medichy's error, 100% credit including shipping expenses will be issued.",
        unusedGoods:
          "Unused goods in original packaging may receive a 75% credit. Customer is responsible for shipping expenses both ways unless otherwise agreed.",
        damagedGoods:
          "Credit for damaged goods depends on the condition of the product. Customer is responsible for shipping expenses.",
        nonReturnableItems:
          "No credit will be issued for non-returnable items such as new products, custom orders, special orders, or items damaged due to improper handling or packaging by the customer.",
      },

      shippingCharges: {
        deliveryResponsibility:
          "Customers are responsible for ensuring delivery access for large trucks and equipment.",
        dockToDock:
          "Basic shipping includes dock-to-dock and/or liftgate service for palletized items only and does not include inside delivery.",
        residentialShipping:
          "Residential shipping charges apply for deliveries to residential areas.",
        insideDelivery:
          "Inside delivery includes delivery to the building lobby only and excludes rooms, suites, elevators, and stairs.",
        packingDisposal:
          "Customers are responsible for disposing of packing materials.",
      },

      warranty: {
        refurbishedWarranty:
          "Refurbished products are tested to Medichy quality standards and covered against defects in material or workmanship.",

        coverage: {
          partsAndLabor:
            "90 days parts and labor from the documented date of receipt.",
          extendedWarranty:
            "Extended warranties up to 1 year from purchase date are available.",
        },

        replacementPolicy:
          "Medichy may replace defective products, repair them, or refund the purchase price if replacement or repair is not practical.",

        nonCoveredIssues: [
          "Normal wear and tear",
          "Improper installation",
          "Improper maintenance",
          "Misuse",
          "Abuse",
          "Negligence",
          "Accidents",
          "Alterations",
        ],

        voidConditions:
          "Warranty is void if labels are removed, damaged, tampered with, or if unauthorized alterations are made.",

        warrantyClaimRequirements: [
          "Invoice or proof of purchase",
          "Description of the problem",
          "Return Authorization Number (RMA#)",
        ],

        returnShipping:
          "Repaired or replacement products will be returned postage prepaid.",

        liabilityLimitation:
          "Medichy is not liable for incidental, special, or consequential damages arising from warranty breaches.",

        governingLaw:
          "The laws of the State of Delaware, USA govern these warranties.",
      },
    },
  },
  {
    id: 12,
    name: "Ferno 35-X ProFlexx Ambulance Cot Stretcher - Refurbished",
    model: "MDYX-FERNO-35X",
    price: "5390",
    by: "Ferno",
    moq: 6,
    condition: "Certified Refurbished",
    shipping: "Freight Shipping",
    images: ["/Equipments/twelve/FERNO-35X-PXAME.webp"],
    feature:
      "The 35-X PROFlexX provides industry leading stability and safety and reduces the chance of injury to you or your patients. A rigid C-channel and carefully designed frame geometry reduce your chance of tipping or flipping the cot. And the exclusive EZ-Pull release handle reduces wrist strain and helps you position yourself before you assume the weight of the cot. When you buy a refurbished item from Medichy, you can buy it with confidence, knowing the components have been disassembled, inspected, tested, and cleaned during each stage of the process.",
    specifications: [
      {
        title: "Specifications",
        measurements: [
          "Length: 79 in",
          "Width: 24 in",
          "Height: 35 in",
          "Weight Capacity: 700 lb",
          "Construction: Metal",
          "Handles: (2) Telescoping",
          "Strapping Type: Nylon Webbing with Metal Buckle",
          "Straps Count: 3",
          "Wheels: 4",
          "Includes: Mattress and Patient Restraints",
        ],
      },
    ],
    keyFeatures: [
      "Easy-pull release handle",
      "One handed side arm release",
      "Ratchet bar guard",
      "Dual wheel lock",
      "Gas assist backrest",
      "Powder coated frame",
      "All-metal frame",
      "Built-in shock frame",
      "Compatible with Ferno Model 175 Antler & Rail Fastening system",
      "One handed drop frame",
      "One handed safety bail release",
      "Backrest adjusts 0-65 degrees",
      "Wider bed surface and head frame",
      "Food-End lead handle",
    ],
    includedAccessories: [],
    policies: {
      returnPolicy: {
        damagedFreight:
          "Damaged freight must be reported within 24 hours to file a claim.",
        authorizationRequired:
          "No merchandise may be returned without prior written authorization by Medichy.",
        newMerchandise:
          "No new merchandise may be returned without manufacturer authorization, which may result in a restocking fee or denial of return. Customer is responsible for shipping expenses.",
        returnPeriod:
          "Products may be returned within thirty (30) days from delivery unless otherwise agreed upon.",
        inspection:
          "Medichy reserves the right to test returned products and may impose a fee if the condition of the product was misrepresented by the customer.",
      },

      creditAndReturnShippingGuidelines: {
        restockingFee:
          "Order cancellations after 24 hours and returns are subject to a 25% restocking fee.",
        medichyMedicalError:
          "If the return is due to Medichy's error, 100% credit including shipping expenses will be issued.",
        unusedGoods:
          "Unused goods in original packaging may receive a 75% credit. Customer is responsible for shipping expenses both ways unless otherwise agreed.",
        damagedGoods:
          "Credit for damaged goods depends on the condition of the product. Customer is responsible for shipping expenses.",
        nonReturnableItems:
          "No credit will be issued for non-returnable items such as new products, custom orders, special orders, or items damaged due to improper handling or packaging by the customer.",
      },

      shippingCharges: {
        deliveryResponsibility:
          "Customers are responsible for ensuring delivery access for large trucks and equipment.",
        dockToDock:
          "Basic shipping includes dock-to-dock and/or liftgate service for palletized items only and does not include inside delivery.",
        residentialShipping:
          "Residential shipping charges apply for deliveries to residential areas.",
        insideDelivery:
          "Inside delivery includes delivery to the building lobby only and excludes rooms, suites, elevators, and stairs.",
        packingDisposal:
          "Customers are responsible for disposing of packing materials.",
      },

      warranty: {
        refurbishedWarranty:
          "Refurbished products are tested to Medichy quality standards and covered against defects in material or workmanship.",

        coverage: {
          partsAndLabor:
            "90 days parts and labor from the documented date of receipt.",
          extendedWarranty:
            "Extended warranties up to 1 year from purchase date are available.",
        },

        replacementPolicy:
          "Medichy may replace defective products, repair them, or refund the purchase price if replacement or repair is not practical.",

        nonCoveredIssues: [
          "Normal wear and tear",
          "Improper installation",
          "Improper maintenance",
          "Misuse",
          "Abuse",
          "Negligence",
          "Accidents",
          "Alterations",
        ],

        voidConditions:
          "Warranty is void if labels are removed, damaged, tampered with, or if unauthorized alterations are made.",

        warrantyClaimRequirements: [
          "Invoice or proof of purchase",
          "Description of the problem",
          "Return Authorization Number (RMA#)",
        ],

        returnShipping:
          "Repaired or replacement products will be returned postage prepaid.",

        liabilityLimitation:
          "Medichy is not liable for incidental, special, or consequential damages arising from warranty breaches.",

        governingLaw:
          "The laws of the State of Delaware, USA govern these warranties.",
      },
    },
  },
  {
    id: 14,
    name: "GE Ohmeda Giraffe Omnibed Incubator - Refurbished",
    model: "MDYX-GE-GIRAFFE",
    price: "5995",
    by: "GE Datex Ohmeda",
    moq: 5,
    condition: "Certified Refurbished",
    shipping: "Freight Shipping",
    images: ["/Equipments/fourteen/OHM-GIRAFFE-OMNI3328.webp"],
    feature:
      "The GE Healthcare Giraffe OmniBed combines two traditional infant care products in one. A full-featured incubator and a radiant warmer in one. Protects from heat loss while the bi-directional maintains thermal stability. Infant receives uniform heat regardless of position. Designed with babies, and their families in mind, the Giraffe OmniBed creates a controlled, protected microenvironment for peaceful, fast healing.",
    specifications: [
      {
        title: "Dimensions",
        measurements: [
          "Maximum height (Canopy down): 70 in (178 cm)",
          "Maximum height (Canopy up): 94 in (239 cm)",
          "Minimum height (Canopy down): 58 in (147 cm)",
          "Minimum height (Canopy up): 82 in (208 cm)",
          "Footprint: 45 in × 26 in (114 cm × 66 cm)",
          "Weight: 284 lbs (129 kg)",
          "Floor to mattress height: 32 in to 44 in (81 cm to 111 cm)",
          "Mattress size: 26 in × 19 in (66 cm × 48 cm)",
          "Access door size: 9 in × 31 in (23 cm × 78 cm)",
          "Drawer size: 19 in × 20 in (48 cm × 50 cm)",
          "Drawer depth: 8 in (20 cm)",
        ],
      },
    ],
    keyFeatures: [
      "Incubator with an Air Curtain to protect from heat loss",
      "Radiant warmer that provides consistent heat in any position",
      "A consistent and controlled thermal environment",
      "Improved access to patient",
      "A less stressful environment for the patient and family",
      "No need to transfer patient from incubator to infant warmer",
      "360 degree rotating patient mattress",
      "Drop down removable doors and rotating bed provide easy access",
    ],
    includedAccessories: [],
    policies: {
      returnPolicy: {
        damagedFreight:
          "Damaged freight must be reported within 24 hours to file a claim.",
        authorizationRequired:
          "No merchandise may be returned without prior written authorization by Medichy.",
        newMerchandise:
          "No new merchandise may be returned without manufacturer authorization, which may result in a restocking fee or denial of return. Customer is responsible for shipping expenses.",
        returnPeriod:
          "Products may be returned within thirty (30) days from delivery unless otherwise agreed upon.",
        inspection:
          "Medichy reserves the right to test returned products and may impose a fee if the condition of the product was misrepresented by the customer.",
      },

      creditAndReturnShippingGuidelines: {
        restockingFee:
          "Order cancellations after 24 hours and returns are subject to a 25% restocking fee.",
        medichyMedicalError:
          "If the return is due to Medichy's error, 100% credit including shipping expenses will be issued.",
        unusedGoods:
          "Unused goods in original packaging may receive a 75% credit. Customer is responsible for shipping expenses both ways unless otherwise agreed.",
        damagedGoods:
          "Credit for damaged goods depends on the condition of the product. Customer is responsible for shipping expenses.",
        nonReturnableItems:
          "No credit will be issued for non-returnable items such as new products, custom orders, special orders, or items damaged due to improper handling or packaging by the customer.",
      },

      shippingCharges: {
        deliveryResponsibility:
          "Customers are responsible for ensuring delivery access for large trucks and equipment.",
        dockToDock:
          "Basic shipping includes dock-to-dock and/or liftgate service for palletized items only and does not include inside delivery.",
        residentialShipping:
          "Residential shipping charges apply for deliveries to residential areas.",
        insideDelivery:
          "Inside delivery includes delivery to the building lobby only and excludes rooms, suites, elevators, and stairs.",
        packingDisposal:
          "Customers are responsible for disposing of packing materials.",
      },

      warranty: {
        refurbishedWarranty:
          "Refurbished products are tested to Medichy quality standards and covered against defects in material or workmanship.",

        coverage: {
          partsAndLabor:
            "90 days parts and labor from the documented date of receipt.",
          extendedWarranty:
            "Extended warranties up to 1 year from purchase date are available.",
        },

        replacementPolicy:
          "Medichy may replace defective products, repair them, or refund the purchase price if replacement or repair is not practical.",

        nonCoveredIssues: [
          "Normal wear and tear",
          "Improper installation",
          "Improper maintenance",
          "Misuse",
          "Abuse",
          "Negligence",
          "Accidents",
          "Alterations",
        ],

        voidConditions:
          "Warranty is void if labels are removed, damaged, tampered with, or if unauthorized alterations are made.",

        warrantyClaimRequirements: [
          "Invoice or proof of purchase",
          "Description of the problem",
          "Return Authorization Number (RMA#)",
        ],

        returnShipping:
          "Repaired or replacement products will be returned postage prepaid.",

        liabilityLimitation:
          "Medichy is not liable for incidental, special, or consequential damages arising from warranty breaches.",

        governingLaw:
          "The laws of the State of Delaware, USA govern these warranties.",
      },
    },
  },
  {
    id: 15,
    name: "Olympus LF-GP Intubation Scope - Refurbished",
    model: "MDYX-OLYMPUS-LFGP",
    price: "2895",
    by: "Olympus",
    moq: 5,
    condition: "Certified Refurbished",
    shipping: "Freight Shipping",
    images: ["/Equipments/fifteen/3348-OLYM-INTSCO-LF-GP.jpg"],
    feature:
      "As part of the Olympus PortaView-LF series, the LF-GP is a complete, all-in-one portable solution for emergency, bedside, operating room, and ICU tracheal intubations. Compatible with single-lumen endotracheal tubes with an internal diameter as small as 5 mm, as well as double-lumen tubes 37 Fr. or greater, the LF-GP is the most versatile scope of the PortaView-LF series. The scope's superb optics and integrated miniature light source result in bright, high-resolution images for observation. In addition, the LF-GP offers an expanded view-field size - 2.2x larger than the LF-2 scope - for even greater image detail.",
    specifications: [],
    keyFeatures: [],
    includedAccessories: [],
    policies: {
      returnPolicy: {
        damagedFreight:
          "Damaged freight must be reported within 24 hours to file a claim.",
        authorizationRequired:
          "No merchandise may be returned without prior written authorization by Medichy.",
        newMerchandise:
          "No new merchandise may be returned without manufacturer authorization, which may result in a restocking fee or denial of return. Customer is responsible for shipping expenses.",
        returnPeriod:
          "Products may be returned within thirty (30) days from delivery unless otherwise agreed upon.",
        inspection:
          "Medichy reserves the right to test returned products and may impose a fee if the condition of the product was misrepresented by the customer.",
      },

      creditAndReturnShippingGuidelines: {
        restockingFee:
          "Order cancellations after 24 hours and returns are subject to a 25% restocking fee.",
        medichyMedicalError:
          "If the return is due to Medichy's error, 100% credit including shipping expenses will be issued.",
        unusedGoods:
          "Unused goods in original packaging may receive a 75% credit. Customer is responsible for shipping expenses both ways unless otherwise agreed.",
        damagedGoods:
          "Credit for damaged goods depends on the condition of the product. Customer is responsible for shipping expenses.",
        nonReturnableItems:
          "No credit will be issued for non-returnable items such as new products, custom orders, special orders, or items damaged due to improper handling or packaging by the customer.",
      },

      shippingCharges: {
        deliveryResponsibility:
          "Customers are responsible for ensuring delivery access for large trucks and equipment.",
        dockToDock:
          "Basic shipping includes dock-to-dock and/or liftgate service for palletized items only and does not include inside delivery.",
        residentialShipping:
          "Residential shipping charges apply for deliveries to residential areas.",
        insideDelivery:
          "Inside delivery includes delivery to the building lobby only and excludes rooms, suites, elevators, and stairs.",
        packingDisposal:
          "Customers are responsible for disposing of packing materials.",
      },

      warranty: {
        refurbishedWarranty:
          "Refurbished products are tested to Medichy quality standards and covered against defects in material or workmanship.",

        coverage: {
          partsAndLabor:
            "90 days parts and labor from the documented date of receipt.",
          extendedWarranty:
            "Extended warranties up to 1 year from purchase date are available.",
        },

        replacementPolicy:
          "Medichy may replace defective products, repair them, or refund the purchase price if replacement or repair is not practical.",

        nonCoveredIssues: [
          "Normal wear and tear",
          "Improper installation",
          "Improper maintenance",
          "Misuse",
          "Abuse",
          "Negligence",
          "Accidents",
          "Alterations",
        ],

        voidConditions:
          "Warranty is void if labels are removed, damaged, tampered with, or if unauthorized alterations are made.",

        warrantyClaimRequirements: [
          "Invoice or proof of purchase",
          "Description of the problem",
          "Return Authorization Number (RMA#)",
        ],

        returnShipping:
          "Repaired or replacement products will be returned postage prepaid.",

        liabilityLimitation:
          "Medichy is not liable for incidental, special, or consequential damages arising from warranty breaches.",

        governingLaw:
          "The laws of the State of Delaware, USA govern these warranties.",
      },
    },
  },
  {
    id: 16,
    name: "Amsco Quantum SQ240 Dual Surgery Light Refurbished",
    model: "MDYX-AMSCO-QUANTUM",
    price: "6390",
    by: "Amsco",
    moq: 10,
    condition: "Certified Refurbished",
    shipping: "Freight Shipping",
    images: ["/Equipments/sixteen/AMS_QUA-SQ240.jpg"],
    feature:
      "Surgical lighting fixture with central hub mount, from which two horizontal arms radiate. Each fixture includes a central hub and two lighthead/suspension arm assemblies. The rotary suspension shaft of the surgical lighthead moves on tapered roller bearings at one end of the horizontal arm.",
    specifications: [],
    keyFeatures: [
      "Depth of Field: 26 inches",
      "Cylinder of Light: 18 inches",
      "Peak Intensity: 18 inches",
      "Intensity Levels: Up to 10,000 footcandles or 107,600 lux",
      "Cool Illumination: Optical coatings remove 98% of all unwanted heat",
      "Color Rendering Index: 92",
      "Continuous Rotation: 360° at all critical joints",
      "Lateral Illumination: 90°",
      "Continuous Light: If a lamp fails, automatically changes to spare lamp",
      "Lamp Life: 1,000 hours",
    ],
    includedAccessories: [],
    policies: {
      returnPolicy: {
        damagedFreight:
          "Damaged freight must be reported within 24 hours to file a claim.",
        authorizationRequired:
          "No merchandise may be returned without prior written authorization by Medichy.",
        newMerchandise:
          "No new merchandise may be returned without manufacturer authorization, which may result in a restocking fee or denial of return. Customer is responsible for shipping expenses.",
        returnPeriod:
          "Products may be returned within thirty (30) days from delivery unless otherwise agreed upon.",
        inspection:
          "Medichy reserves the right to test returned products and may impose a fee if the condition of the product was misrepresented by the customer.",
      },

      creditAndReturnShippingGuidelines: {
        restockingFee:
          "Order cancellations after 24 hours and returns are subject to a 25% restocking fee.",
        medichyMedicalError:
          "If the return is due to Medichy's error, 100% credit including shipping expenses will be issued.",
        unusedGoods:
          "Unused goods in original packaging may receive a 75% credit. Customer is responsible for shipping expenses both ways unless otherwise agreed.",
        damagedGoods:
          "Credit for damaged goods depends on the condition of the product. Customer is responsible for shipping expenses.",
        nonReturnableItems:
          "No credit will be issued for non-returnable items such as new products, custom orders, special orders, or items damaged due to improper handling or packaging by the customer.",
      },

      shippingCharges: {
        deliveryResponsibility:
          "Customers are responsible for ensuring delivery access for large trucks and equipment.",
        dockToDock:
          "Basic shipping includes dock-to-dock and/or liftgate service for palletized items only and does not include inside delivery.",
        residentialShipping:
          "Residential shipping charges apply for deliveries to residential areas.",
        insideDelivery:
          "Inside delivery includes delivery to the building lobby only and excludes rooms, suites, elevators, and stairs.",
        packingDisposal:
          "Customers are responsible for disposing of packing materials.",
      },

      warranty: {
        refurbishedWarranty:
          "Refurbished products are tested to Medichy quality standards and covered against defects in material or workmanship.",

        coverage: {
          partsAndLabor:
            "90 days parts and labor from the documented date of receipt.",
          extendedWarranty:
            "Extended warranties up to 1 year from purchase date are available.",
        },

        replacementPolicy:
          "Medichy may replace defective products, repair them, or refund the purchase price if replacement or repair is not practical.",

        nonCoveredIssues: [
          "Normal wear and tear",
          "Improper installation",
          "Improper maintenance",
          "Misuse",
          "Abuse",
          "Negligence",
          "Accidents",
          "Alterations",
        ],

        voidConditions:
          "Warranty is void if labels are removed, damaged, tampered with, or if unauthorized alterations are made.",

        warrantyClaimRequirements: [
          "Invoice or proof of purchase",
          "Description of the problem",
          "Return Authorization Number (RMA#)",
        ],

        returnShipping:
          "Repaired or replacement products will be returned postage prepaid.",

        liabilityLimitation:
          "Medichy is not liable for incidental, special, or consequential damages arising from warranty breaches.",

        governingLaw:
          "The laws of the State of Delaware, USA govern these warranties.",
      },
    },
  },
  {
    id: 17,
    name: "Hill-Rom Affinity IV 4 Birthing Bed Refurbished",
    model: "MDYX-HILLROM-AFFINITY4",
    price: "3690",
    by: "Hill-Rom",
    moq: 10,
    condition: "Certified Refurbished",
    shipping: "Freight Shipping",
    images: ["/Equipments/seventeen/HILL-P3700-RAM.webp"],
    feature:
      "The Affinity 4 is designed to help make the birthing process safe for the patient and caregiver. It allows for caregivers to respond and adjust quickly and efficiently to patient delivery needs even in emergency situations. Even when it is far away from an outlet, the battery backup feature will ensure that all of the bed's features may be used. In labor and delivery, every second counts, which is why it is important to have such a versatile and responsive Birthing Bed system. Stow and Go No-lift Patient Foot Section (optional): Convenient, stow away foot section stores under the bed, eliminating lifting and saving you valuable space in the birthing suite.",
    specifications: [
      {
        title: "Bed Specifications",
        measurements: [
          "Bed Length (Full): 90 in (229 cm)",
          "Bed Width (Side rails up): 39 in (99 cm)",
          "Bed Width (Side rails down): 36 in (91 cm)",
          "Bed Height Low (with mattress): 24 in (61 cm)",
          "Bed Height High (with mattress): 39 in (99 cm)",
          "Mattress Length: 78 in (98 cm)",
          "Mattress Width: 35 in (89 cm)",
          "Maximum Head Elevation: 63°",
          "Maximum Seat Elevation: 15°",
          "Maximum Trend-like positioning: 8°",
          "Maximum Lift Capacity: 500 lb (227 kg)",
          "Bed Weight: 480 lb (218 kg)",
        ],
      },
    ],
    keyFeatures: [
      "EasyGlide Calf Support",
      "SideCom Communication System",
      "Light Weight Lift-Off Foot Section",
      "Battery backup",
      "Zero transfer gap with OneStep siderail release",
      "Easy-to-use, gas-assisted Trend mechanism",
      "Four dual-lock casters",
      "Automatic pelvic tilt",
      "Automatic night light",
      "Automatic seat tilt",
      "Blow-molded headboard",
      "Fluid basin",
      "Central brake and steering",
      "Instant CPR release",
      "Lockout control/indicator",
      "Labor grips",
      "IV pole",
      "Foot supports",
    ],
    includedAccessories: [
      "5 inch mattress",
      "Four dual locking casters",
      "Fluid basin",
      "Birthing Bed",
      "Power Cord",
    ],
    policies: {
      returnPolicy: {
        damagedFreight:
          "Damaged freight must be reported within 24 hours to file a claim.",
        authorizationRequired:
          "No merchandise may be returned without prior written authorization by Medichy.",
        newMerchandise:
          "No new merchandise may be returned without manufacturer authorization, which may result in a restocking fee or denial of return. Customer is responsible for shipping expenses.",
        returnPeriod:
          "Products may be returned within thirty (30) days from delivery unless otherwise agreed upon.",
        inspection:
          "Medichy reserves the right to test returned products and may impose a fee if the condition of the product was misrepresented by the customer.",
      },

      creditAndReturnShippingGuidelines: {
        restockingFee:
          "Order cancellations after 24 hours and returns are subject to a 25% restocking fee.",
        medichyMedicalError:
          "If the return is due to Medichy's error, 100% credit including shipping expenses will be issued.",
        unusedGoods:
          "Unused goods in original packaging may receive a 75% credit. Customer is responsible for shipping expenses both ways unless otherwise agreed.",
        damagedGoods:
          "Credit for damaged goods depends on the condition of the product. Customer is responsible for shipping expenses.",
        nonReturnableItems:
          "No credit will be issued for non-returnable items such as new products, custom orders, special orders, or items damaged due to improper handling or packaging by the customer.",
      },

      shippingCharges: {
        deliveryResponsibility:
          "Customers are responsible for ensuring delivery access for large trucks and equipment.",
        dockToDock:
          "Basic shipping includes dock-to-dock and/or liftgate service for palletized items only and does not include inside delivery.",
        residentialShipping:
          "Residential shipping charges apply for deliveries to residential areas.",
        insideDelivery:
          "Inside delivery includes delivery to the building lobby only and excludes rooms, suites, elevators, and stairs.",
        packingDisposal:
          "Customers are responsible for disposing of packing materials.",
      },

      warranty: {
        refurbishedWarranty:
          "Refurbished products are tested to Medichy quality standards and covered against defects in material or workmanship.",

        coverage: {
          partsAndLabor:
            "90 days parts and labor from the documented date of receipt.",
          extendedWarranty:
            "Extended warranties up to 1 year from purchase date are available.",
        },

        replacementPolicy:
          "Medichy may replace defective products, repair them, or refund the purchase price if replacement or repair is not practical.",

        nonCoveredIssues: [
          "Normal wear and tear",
          "Improper installation",
          "Improper maintenance",
          "Misuse",
          "Abuse",
          "Negligence",
          "Accidents",
          "Alterations",
        ],

        voidConditions:
          "Warranty is void if labels are removed, damaged, tampered with, or if unauthorized alterations are made.",

        warrantyClaimRequirements: [
          "Invoice or proof of purchase",
          "Description of the problem",
          "Return Authorization Number (RMA#)",
        ],

        returnShipping:
          "Repaired or replacement products will be returned postage prepaid.",

        liabilityLimitation:
          "Medichy is not liable for incidental, special, or consequential damages arising from warranty breaches.",

        governingLaw:
          "The laws of the State of Delaware, USA govern these warranties.",
      },
    },
  },
  {
    id: 18,
    name: "Hill-Rom Affinity III 3 Birthing Bed Refurbished",
    model: "MDYX-HILLROM-AFFINITY3",
    price: "2390",
    by: "Hill-Rom",
    moq: 10,
    condition: "Certified Refurbished",
    shipping: "Freight Shipping",
    images: ["/Equipments/eighteen/HILL-P3700A-ROM.jpg"],
    feature:
      'The Hill-Rom Affinity III (#P3700) is intended for use as a birthing bed within the acute care Labor and Delivery Unit. Includes a new 6" Hospital-Grade Memory Foam Mattress and available with optional calf supports. It is in excellent condition and refurbished to proper operating specifications. It has multiple articulation features, ergonomic hand grips, and a steering control headboard. Three independent motors raise and lower the bed, foot section, and head section. Calf supports for this bed may be manually adjusted and will lock when in the upright position, and the foot section of this bed slides off and may be stowed until once again needed.',
    specifications: [],
    keyFeatures: [
      "SideCom Communication System - Nurse call",
      "Instant CPR lowers head from elevated to flat position",
      "CPR Release: Emergency lowering",
      "Manual operation",
      "Battery backup LED indicators",
      "Bed Height (Hilow) Motor",
      "Foot Section Motor",
      "Head Section Motor",
      "Auxiliary outlet for accessories",
      "Headboard mounted on metal frame with built-in handles",
      "Automatic Tilting",
      "Docking/Wall Protection: Standard roller bumpers",
      "Lockout Control Switch",
      "Night Light",
      "Foot Support",
      "Labor Grips",
      "Side Rails",
      "Braking/Steer System",
    ],
    includedAccessories: [
      "5 inch mattress",
      "Four dual locking casters",
      "Fluid basin",
      "Birthing Bed",
      "Power Cord",
    ],
    policies: {
      returnPolicy: {
        damagedFreight:
          "Damaged freight must be reported within 24 hours to file a claim.",
        authorizationRequired:
          "No merchandise may be returned without prior written authorization by Medichy.",
        newMerchandise:
          "No new merchandise may be returned without manufacturer authorization, which may result in a restocking fee or denial of return. Customer is responsible for shipping expenses.",
        returnPeriod:
          "Products may be returned within thirty (30) days from delivery unless otherwise agreed upon.",
        inspection:
          "Medichy reserves the right to test returned products and may impose a fee if the condition of the product was misrepresented by the customer.",
      },

      creditAndReturnShippingGuidelines: {
        restockingFee:
          "Order cancellations after 24 hours and returns are subject to a 25% restocking fee.",
        medichyMedicalError:
          "If the return is due to Medichy's error, 100% credit including shipping expenses will be issued.",
        unusedGoods:
          "Unused goods in original packaging may receive a 75% credit. Customer is responsible for shipping expenses both ways unless otherwise agreed.",
        damagedGoods:
          "Credit for damaged goods depends on the condition of the product. Customer is responsible for shipping expenses.",
        nonReturnableItems:
          "No credit will be issued for non-returnable items such as new products, custom orders, special orders, or items damaged due to improper handling or packaging by the customer.",
      },

      shippingCharges: {
        deliveryResponsibility:
          "Customers are responsible for ensuring delivery access for large trucks and equipment.",
        dockToDock:
          "Basic shipping includes dock-to-dock and/or liftgate service for palletized items only and does not include inside delivery.",
        residentialShipping:
          "Residential shipping charges apply for deliveries to residential areas.",
        insideDelivery:
          "Inside delivery includes delivery to the building lobby only and excludes rooms, suites, elevators, and stairs.",
        packingDisposal:
          "Customers are responsible for disposing of packing materials.",
      },

      warranty: {
        refurbishedWarranty:
          "Refurbished products are tested to Medichy quality standards and covered against defects in material or workmanship.",

        coverage: {
          partsAndLabor:
            "90 days parts and labor from the documented date of receipt.",
          extendedWarranty:
            "Extended warranties up to 1 year from purchase date are available.",
        },

        replacementPolicy:
          "Medichy may replace defective products, repair them, or refund the purchase price if replacement or repair is not practical.",

        nonCoveredIssues: [
          "Normal wear and tear",
          "Improper installation",
          "Improper maintenance",
          "Misuse",
          "Abuse",
          "Negligence",
          "Accidents",
          "Alterations",
        ],

        voidConditions:
          "Warranty is void if labels are removed, damaged, tampered with, or if unauthorized alterations are made.",

        warrantyClaimRequirements: [
          "Invoice or proof of purchase",
          "Description of the problem",
          "Return Authorization Number (RMA#)",
        ],

        returnShipping:
          "Repaired or replacement products will be returned postage prepaid.",

        liabilityLimitation:
          "Medichy is not liable for incidental, special, or consequential damages arising from warranty breaches.",

        governingLaw:
          "The laws of the State of Delaware, USA govern these warranties.",
      },
    },
  },
  {
    id: 19,
    name: "Medical Mammography Equipment Mammogram Machine Digital AEC, High Quality Xray Machine",
    model: "MDYX-685-3204",
    price: "9999 - 52000",
    by: "Medichy",
    moq: 4,
    condition: "Certified Refurbished",
    shipping: "Freight Shipping",
    images: [
      "/BigEquipments/nine/1.jpg",
      "/BigEquipments/nine/2.jpg",
      "/BigEquipments/nine/3.jpg",
      "/BigEquipments/nine/4.jpg",
      "/BigEquipments/nine/5.jpg",
      "/BigEquipments/nine/6.jpg",
    ],
    feature:
      "The Digital Mammography System is a Class II CE-certified medical imaging solution designed for reliable and high-performance breast examination procedures. Built with durable acrylic and metal materials, this electric-powered system complies with GB2626-2006 safety standards and features a high-frequency 80kHz inverter generator with a 6.2kW power rating for efficient imaging performance.",
    keyFeatures: [],
    specifications: [
      {
        title: "X-ray Generator",
        measurements: [
          "Generator Type: High Frequency Inverter 80kHz",
          "Input Power: Single Phase 220VAC, 50/60Hz",
          "Large Focal Point: 20-35kV / 10-510mAs",
          "Small Focal Point: 20-35kV / 10-100mAs",
          "Power Rating: 6kW",
        ],
      },
      {
        title: "X-ray Tube",
        measurements: [
          "Model: China Hangzhou LR01",
          "Focal Spot Size: Dual Focus 0.2 / 0.4mm",
          "Target Material: Molybdenum (Mo)",
          "Port Material: Beryllium (Be)",
          "High-speed Anode Drive: 2800rpm",
          "Target Angle: 12°",
          "Anode Heat Storage: 80KJ",
          "Anode Cooling: Air Cooling",
          "Filtration: Mo (0.03mm)",
        ],
      },
    ],
    includedAccessories: [],
    policies: {
      returnPolicy: {
        damagedFreight:
          "Damaged freight must be reported within 24 hours to file a claim.",
        authorizationRequired:
          "No merchandise may be returned without prior written authorization by Medichy.",
        newMerchandise:
          "No new merchandise may be returned without manufacturer authorization, which may result in a restocking fee or denial of return. Customer is responsible for shipping expenses.",
        returnPeriod:
          "Products may be returned within thirty (30) days from delivery unless otherwise agreed upon.",
        inspection:
          "Medichy reserves the right to test returned products and may impose a fee if the condition of the product was misrepresented by the customer.",
      },

      creditAndReturnShippingGuidelines: {
        restockingFee:
          "Order cancellations after 24 hours and returns are subject to a 25% restocking fee.",
        medichyMedicalError:
          "If the return is due to Medichy's error, 100% credit including shipping expenses will be issued.",
        unusedGoods:
          "Unused goods in original packaging may receive a 75% credit. Customer is responsible for shipping expenses both ways unless otherwise agreed.",
        damagedGoods:
          "Credit for damaged goods depends on the condition of the product. Customer is responsible for shipping expenses.",
        nonReturnableItems:
          "No credit will be issued for non-returnable items such as new products, custom orders, special orders, or items damaged due to improper handling or packaging by the customer.",
      },

      shippingCharges: {
        deliveryResponsibility:
          "Customers are responsible for ensuring delivery access for large trucks and equipment.",
        dockToDock:
          "Basic shipping includes dock-to-dock and/or liftgate service for palletized items only and does not include inside delivery.",
        residentialShipping:
          "Residential shipping charges apply for deliveries to residential areas.",
        insideDelivery:
          "Inside delivery includes delivery to the building lobby only and excludes rooms, suites, elevators, and stairs.",
        packingDisposal:
          "Customers are responsible for disposing of packing materials.",
      },

      warranty: {
        refurbishedWarranty:
          "Refurbished products are tested to Medichy quality standards and covered against defects in material or workmanship.",

        coverage: {
          partsAndLabor:
            "90 days parts and labor from the documented date of receipt.",
          extendedWarranty:
            "Extended warranties up to 1 year from purchase date are available.",
        },

        replacementPolicy:
          "Medichy may replace defective products, repair them, or refund the purchase price if replacement or repair is not practical.",

        nonCoveredIssues: [
          "Normal wear and tear",
          "Improper installation",
          "Improper maintenance",
          "Misuse",
          "Abuse",
          "Negligence",
          "Accidents",
          "Alterations",
        ],

        voidConditions:
          "Warranty is void if labels are removed, damaged, tampered with, or if unauthorized alterations are made.",

        warrantyClaimRequirements: [
          "Invoice or proof of purchase",
          "Description of the problem",
          "Return Authorization Number (RMA#)",
        ],

        returnShipping:
          "Repaired or replacement products will be returned postage prepaid.",

        liabilityLimitation:
          "Medichy is not liable for incidental, special, or consequential damages arising from warranty breaches.",

        governingLaw:
          "The laws of the State of Delaware, USA govern these warranties.",
      },
    },
  },
  {
    id: 20,
    name: "Portable Digital Mammography Equipment for Hospital Inspection",
    model: "MDYX-147-8569",
    price: "49000-88000",
    by: "Medichy",
    moq: 4,
    condition: "Certified Refurbished",
    shipping: "Freight Shipping",
    images: [
      "/BigEquipments/ten/1.png",
      "/BigEquipments/ten/2.jpg",
      "/BigEquipments/ten/3.jpg",
      "/BigEquipments/ten/4.jpg",
      "/BigEquipments/ten/5.jpg",
    ],
    feature:
      "This medical imaging system is a CE-certified Class I diagnostic solution designed for reliable and high-precision clinical imaging applications. Constructed with durable metal, plastic, and steel materials, this electric-powered system complies with GB/T18830-2009 safety standards and is built for long-term operational stability.",
    keyFeatures: [],
    specifications: [],
    includedAccessories: [],
    policies: {
      returnPolicy: {
        damagedFreight:
          "Damaged freight must be reported within 24 hours to file a claim.",
        authorizationRequired:
          "No merchandise may be returned without prior written authorization by Medichy.",
        newMerchandise:
          "No new merchandise may be returned without manufacturer authorization, which may result in a restocking fee or denial of return. Customer is responsible for shipping expenses.",
        returnPeriod:
          "Products may be returned within thirty (30) days from delivery unless otherwise agreed upon.",
        inspection:
          "Medichy reserves the right to test returned products and may impose a fee if the condition of the product was misrepresented by the customer.",
      },

      creditAndReturnShippingGuidelines: {
        restockingFee:
          "Order cancellations after 24 hours and returns are subject to a 25% restocking fee.",
        medichyMedicalError:
          "If the return is due to Medichy's error, 100% credit including shipping expenses will be issued.",
        unusedGoods:
          "Unused goods in original packaging may receive a 75% credit. Customer is responsible for shipping expenses both ways unless otherwise agreed.",
        damagedGoods:
          "Credit for damaged goods depends on the condition of the product. Customer is responsible for shipping expenses.",
        nonReturnableItems:
          "No credit will be issued for non-returnable items such as new products, custom orders, special orders, or items damaged due to improper handling or packaging by the customer.",
      },

      shippingCharges: {
        deliveryResponsibility:
          "Customers are responsible for ensuring delivery access for large trucks and equipment.",
        dockToDock:
          "Basic shipping includes dock-to-dock and/or liftgate service for palletized items only and does not include inside delivery.",
        residentialShipping:
          "Residential shipping charges apply for deliveries to residential areas.",
        insideDelivery:
          "Inside delivery includes delivery to the building lobby only and excludes rooms, suites, elevators, and stairs.",
        packingDisposal:
          "Customers are responsible for disposing of packing materials.",
      },

      warranty: {
        refurbishedWarranty:
          "Refurbished products are tested to Medichy quality standards and covered against defects in material or workmanship.",

        coverage: {
          partsAndLabor:
            "90 days parts and labor from the documented date of receipt.",
          extendedWarranty:
            "Extended warranties up to 1 year from purchase date are available.",
        },

        replacementPolicy:
          "Medichy may replace defective products, repair them, or refund the purchase price if replacement or repair is not practical.",

        nonCoveredIssues: [
          "Normal wear and tear",
          "Improper installation",
          "Improper maintenance",
          "Misuse",
          "Abuse",
          "Negligence",
          "Accidents",
          "Alterations",
        ],

        voidConditions:
          "Warranty is void if labels are removed, damaged, tampered with, or if unauthorized alterations are made.",

        warrantyClaimRequirements: [
          "Invoice or proof of purchase",
          "Description of the problem",
          "Return Authorization Number (RMA#)",
        ],

        returnShipping:
          "Repaired or replacement products will be returned postage prepaid.",

        liabilityLimitation:
          "Medichy is not liable for incidental, special, or consequential damages arising from warranty breaches.",

        governingLaw:
          "The laws of the State of Delaware, USA govern these warranties.",
      },
    },
  },
  {
    id: 22,
    name: "64 Slice 128 Layer CT Scan Machine with High Resolution Low Dose Cardiac Medical Imaging System",
    model: "MDYX-907-1148",
    price: "150,000-428,631",
    by: "Medichy",
    moq: 3,
    condition: "Certified Refurbished",
    shipping: "Freight Shipping",
    images: [
      "/BigEquipments/five/1.jpg",
      "/BigEquipments/five/2.jpg",
      "/BigEquipments/five/3.jpg",
      "/BigEquipments/five/4.jpg",
      "/BigEquipments/five/5.jpg",
      "/BigEquipments/five/6.jpg",
    ],
    feature:
      "The X-ray Radiography Machine is a Class I medical imaging system designed for reliable hospital use and advanced diagnostic performance. Powered electrically and built with portable functionality, this system is ideal for modern healthcare environments requiring flexibility and efficiency.",
    keyFeatures: [],
    specifications: [
      {
        title: "Gantry",
        measurements: [
          "Slip Ring: Low-voltage slip ring",
          "Aperture Size: 715mm",
          "Tilt Range: ±30°",
          "Sampling Rate: 1800 view/rotation",
          "Minimum Scan Time (360°): 0.298s",
          "Maximum Field of View (FOV): 500mm",
        ],
      },
      {
        title: "Detector",
        measurements: [
          "Detector Type: GOS ceramic solid detector",
          "Detector Number: 880 × 64",
          "Detector Row: 64",
          "Number of Slices Per Scan: 128",
          "Detector Thickness: 40mm",
        ],
      },
    ],
    includedAccessories: [],
    policies: {
      returnPolicy: {
        damagedFreight:
          "Damaged freight must be reported within 24 hours to file a claim.",
        authorizationRequired:
          "No merchandise may be returned without prior written authorization by Medichy.",
        newMerchandise:
          "No new merchandise may be returned without manufacturer authorization, which may result in a restocking fee or denial of return. Customer is responsible for shipping expenses.",
        returnPeriod:
          "Products may be returned within thirty (30) days from delivery unless otherwise agreed upon.",
        inspection:
          "Medichy reserves the right to test returned products and may impose a fee if the condition of the product was misrepresented by the customer.",
      },

      creditAndReturnShippingGuidelines: {
        restockingFee:
          "Order cancellations after 24 hours and returns are subject to a 25% restocking fee.",
        medichyMedicalError:
          "If the return is due to Medichy's error, 100% credit including shipping expenses will be issued.",
        unusedGoods:
          "Unused goods in original packaging may receive a 75% credit. Customer is responsible for shipping expenses both ways unless otherwise agreed.",
        damagedGoods:
          "Credit for damaged goods depends on the condition of the product. Customer is responsible for shipping expenses.",
        nonReturnableItems:
          "No credit will be issued for non-returnable items such as new products, custom orders, special orders, or items damaged due to improper handling or packaging by the customer.",
      },

      shippingCharges: {
        deliveryResponsibility:
          "Customers are responsible for ensuring delivery access for large trucks and equipment.",
        dockToDock:
          "Basic shipping includes dock-to-dock and/or liftgate service for palletized items only and does not include inside delivery.",
        residentialShipping:
          "Residential shipping charges apply for deliveries to residential areas.",
        insideDelivery:
          "Inside delivery includes delivery to the building lobby only and excludes rooms, suites, elevators, and stairs.",
        packingDisposal:
          "Customers are responsible for disposing of packing materials.",
      },

      warranty: {
        refurbishedWarranty:
          "Refurbished products are tested to Medichy quality standards and covered against defects in material or workmanship.",

        coverage: {
          partsAndLabor:
            "90 days parts and labor from the documented date of receipt.",
          extendedWarranty:
            "Extended warranties up to 1 year from purchase date are available.",
        },

        replacementPolicy:
          "Medichy may replace defective products, repair them, or refund the purchase price if replacement or repair is not practical.",

        nonCoveredIssues: [
          "Normal wear and tear",
          "Improper installation",
          "Improper maintenance",
          "Misuse",
          "Abuse",
          "Negligence",
          "Accidents",
          "Alterations",
        ],

        voidConditions:
          "Warranty is void if labels are removed, damaged, tampered with, or if unauthorized alterations are made.",

        warrantyClaimRequirements: [
          "Invoice or proof of purchase",
          "Description of the problem",
          "Return Authorization Number (RMA#)",
        ],

        returnShipping:
          "Repaired or replacement products will be returned postage prepaid.",

        liabilityLimitation:
          "Medichy is not liable for incidental, special, or consequential damages arising from warranty breaches.",

        governingLaw:
          "The laws of the State of Delaware, USA govern these warranties.",
      },
    },
  },
  {
    id: 23,
    name: "Digital X Ray Machine Full Set Digital Radiography DR X Ray System Medical Imaging Equipment",
    model: "MDYX-743-1906",
    price: "2700 -4650",
    by: "Medichy",
    moq: 10,
    condition: "Certified Refurbished",
    shipping: "Freight Shipping",
    images: [
      "/BigEquipments/thirteen/1.png",
      "/BigEquipments/thirteen/2.jpg",
      "/BigEquipments/thirteen/3.png",
      "/BigEquipments/thirteen/4.jpg",
      "/BigEquipments/thirteen/5.png",
      "/BigEquipments/thirteen/6.png",
    ],
    feature:
      "The KC-197 is a CE-certified Class II electric-powered device designed for both commercial and home use. Built with durable plastic materials and powered through a plug-in power supply mode, the unit offers reliable and convenient operation for a variety of applications.",
    keyFeatures: [],
    specifications: [
      {
        title: "Product Overview",
        measurements: [
          "Portable Digital X Ray Machine designed for medical and veterinary imaging applications",
          "Provides reliable performance, high image clarity, and efficient workflow",
          "Suitable for hospitals, clinics, and animal hospitals",
          "Advanced digital radiography technology for fast image acquisition",
          "Optimized radiation dose control for improved patient and animal safety",
          "Compact and portable design suitable for fixed installation or mobile use",
          "Stable output power with precise exposure control",
          "Supports chest, orthopedic, trauma, and veterinary diagnostics",
          "Compatible with digital X-ray detectors and DR software systems",
          "User-friendly control interface for easy operation and maintenance",
          "Manufactured with durable medical-grade materials",
          "CE and ISO 13485 certified",
          "OEM and ODM customization supported including branding and packaging",
        ],
      },
      {
        title: "Product Specifications",
        measurements: [
          "Product Name: Digital X Ray Machine / Portable X-ray System",
          "Type: Portable / Fixed / Mobile",
          "Application: Medical / Veterinary / Hospital / Clinic",
          "Target Species: Human / Animal / Cattle / Pet",
          "Feature: Digital Radiography / High Resolution / Low Dose / Wireless",
          "Material: Medical-grade Aluminum Alloy / ABS",
          "Power Source: AC 220V / Rechargeable Battery (Portable)",
          "Model Number: DR-XY100 / Custom",
          "Properties: Lightweight / Compact / High Sensitivity / CE Certified",
          "Dimensions: 460 × 460 × 150 mm",
          "Imaging Technology: Digital Radiography (DR) / Flat Panel Detector",
          "Certification: CE / ISO 13485",
          "OEM / ODM: Supported",
          "Operating Temperature: 5℃–35℃",
          "Storage Temperature: -20℃–55℃",
          "Compatible Systems: Mobile X-ray / Fixed X-ray / Portable DR",
        ],
      },
    ],
    includedAccessories: [],
    policies: {
      returnPolicy: {
        damagedFreight:
          "Damaged freight must be reported within 24 hours to file a claim.",
        authorizationRequired:
          "No merchandise may be returned without prior written authorization by Medichy.",
        newMerchandise:
          "No new merchandise may be returned without manufacturer authorization, which may result in a restocking fee or denial of return. Customer is responsible for shipping expenses.",
        returnPeriod:
          "Products may be returned within thirty (30) days from delivery unless otherwise agreed upon.",
        inspection:
          "Medichy reserves the right to test returned products and may impose a fee if the condition of the product was misrepresented by the customer.",
      },

      creditAndReturnShippingGuidelines: {
        restockingFee:
          "Order cancellations after 24 hours and returns are subject to a 25% restocking fee.",
        medichyMedicalError:
          "If the return is due to Medichy's error, 100% credit including shipping expenses will be issued.",
        unusedGoods:
          "Unused goods in original packaging may receive a 75% credit. Customer is responsible for shipping expenses both ways unless otherwise agreed.",
        damagedGoods:
          "Credit for damaged goods depends on the condition of the product. Customer is responsible for shipping expenses.",
        nonReturnableItems:
          "No credit will be issued for non-returnable items such as new products, custom orders, special orders, or items damaged due to improper handling or packaging by the customer.",
      },

      shippingCharges: {
        deliveryResponsibility:
          "Customers are responsible for ensuring delivery access for large trucks and equipment.",
        dockToDock:
          "Basic shipping includes dock-to-dock and/or liftgate service for palletized items only and does not include inside delivery.",
        residentialShipping:
          "Residential shipping charges apply for deliveries to residential areas.",
        insideDelivery:
          "Inside delivery includes delivery to the building lobby only and excludes rooms, suites, elevators, and stairs.",
        packingDisposal:
          "Customers are responsible for disposing of packing materials.",
      },

      warranty: {
        refurbishedWarranty:
          "Refurbished products are tested to Medichy quality standards and covered against defects in material or workmanship.",

        coverage: {
          partsAndLabor:
            "90 days parts and labor from the documented date of receipt.",
          extendedWarranty:
            "Extended warranties up to 1 year from purchase date are available.",
        },

        replacementPolicy:
          "Medichy may replace defective products, repair them, or refund the purchase price if replacement or repair is not practical.",

        nonCoveredIssues: [
          "Normal wear and tear",
          "Improper installation",
          "Improper maintenance",
          "Misuse",
          "Abuse",
          "Negligence",
          "Accidents",
          "Alterations",
        ],

        voidConditions:
          "Warranty is void if labels are removed, damaged, tampered with, or if unauthorized alterations are made.",

        warrantyClaimRequirements: [
          "Invoice or proof of purchase",
          "Description of the problem",
          "Return Authorization Number (RMA#)",
        ],

        returnShipping:
          "Repaired or replacement products will be returned postage prepaid.",

        liabilityLimitation:
          "Medichy is not liable for incidental, special, or consequential damages arising from warranty breaches.",

        governingLaw:
          "The laws of the State of Delaware, USA govern these warranties.",
      },
    },
  },
];
